import { getLanguage } from '@yoweb/utils/intl/locale';

const SUFFIXES = new Map([
  ['one', 'st'],
  ['two', 'nd'],
  ['few', 'rd'],
  ['other', 'th'],
]);

/**
 * Turn a number (ex. 5) into an ordinal string (ex. "5th").
 */
export const getOrdinalNumber = (n: number, locale: string) => {
  if (getLanguage(locale) !== 'en') {
    return n.toString();
  }

  const ordinalRules = new Intl.PluralRules(locale, { type: 'ordinal' });
  const rule = ordinalRules.select(n);
  const suffix = SUFFIXES.get(rule);
  return `${n}${suffix}`;
};
